// Umami analytics event tracking utility

export const trackEvent = (eventName, eventData = {}) => {
  if (window.umami) {
    window.umami.track(eventName, eventData);
  }
};

// Theme events
export const trackThemeToggle = (theme) => {
  trackEvent("theme_toggle", { theme });
};

// Prompt Configuration UI events
export const trackPromptConfigOpen = () => {
  trackEvent("prompt_config_open");
};

export const trackPromptOptionSelect = (option) => {
  trackEvent("prompt_option_select", { option });
};

export const trackPromptOptionDeselect = (option) => {
  trackEvent("prompt_option_deselect", { option });
};

export const trackPromptStyleSelect = (style) => {
  trackEvent("prompt_style_select", { style });
};

export const trackPromptLevelSelect = (level) => {
  trackEvent("prompt_level_select", { level });
};

// Prompt Usage Stats events
export const trackPromptOptionUsage = (option) => {
  trackEvent("prompt_option_usage", { option });
};

export const trackPromptStyleUsage = (style) => {
  trackEvent("prompt_style_usage", { style });
};

export const trackPromptLevelUsage = (level) => {
  trackEvent("prompt_level_usage", { level });
};

// Navigation events
export const trackSectionClick = (sessionId, sectionName, topicCount) => {
  trackEvent("section_click", { sessionId, sectionName, topicCount });
};

export const trackTagClick = (sessionId, tag) => {
  trackEvent("tag_click", { sessionId, tag });
};

export const trackTopicClick = (sessionId, sectionName, topicName) => {
  trackEvent("topic_click", { sessionId, sectionName, topicName });
};

export const trackSectionBack = (sessionId, sectionName) => {
  trackEvent("section_back", { sessionId, sectionName });
};

// Topic events
export const trackTopicSelect = (
  sessionId,
  sectionName,
  topicName,
  promptConfig
) => {
  trackEvent("topic_select", {
    sessionId,
    sectionName,
    topicName,
    promptConfig,
  });
};

// Redirect Popup events
export const trackRedirectPopupShow = (sessionId, topicName) => {
  trackEvent("redirect_popup_show", { sessionId, topicName });
};

export const trackRedirectPopupDontShow = (sessionId, enabled) => {
  trackEvent("redirect_popup_dont_show", { sessionId, enabled });
};

export const trackRedirectPopupAction = (sessionId, action) => {
  trackEvent("redirect_popup_action", {
    sessionId,
    action, // 'confirm' or 'cancel'
  });
};

export const trackChatGPTRedirect = (sessionId, topicName, directRedirect) => {
  trackEvent("chatgpt_redirect", {
    sessionId,
    topicName,
    directRedirect, // true if popup was skipped
  });
};

// Session events
export const trackSessionLoad = (
  sessionId,
  title,
  sectionCount,
  totalTopics
) => {
  trackEvent("session_load", {
    sessionId,
    title,
    sectionCount,
    totalTopics,
  });
};

export const trackSessionError = (sessionId, errorType) => {
  trackEvent("session_error", { sessionId, errorType });
};

// Header events
export const trackGPTButtonClick = () => {
  trackEvent("gpt_button_click");
};
